<template>
  <span :class="themeClass">
        <v-card class=" product-description" style="position:relative; box-shadow:none;border:1px solid #cecece; margin-top:-5px">
                    <v-card-title
                            style="font-size: 14px !important; padding-bottom: 5px; font-weight: 500; padding-top: 10px;word-break: break-word; line-height: 1.2;    "
                            class="headline"><span v-html="$t('paymentForm.title')"></span></v-card-title>
                    <v-card-title
                            style="font-size:14px!important;position:absolute;right:-10px;top:-18px;font-weight:700;width:110px;"
                            class="headline">


                    </v-card-title>

                    <v-card-text class="product-description-subtitle" style="font-size:12px!important;    line-height: 1.2;padding-bottom:10px;" v-html="cardText">

                    </v-card-text>
                </v-card>

      <v-row  style="margin:0;margin: 0px;" class=" d-flex justify-center">
 <v-radio-group
         class="subscription-types"
         v-model="selectedSubscription"
         row
         style="width: 100%;margin-top:2px;    margin-bottom: -27px;"
 >
        <v-col class="subscription-type" cols="4" v-for="subscriptionType in subscriptionTypes" :key="subscriptionType.id">
         <v-card class="subscription-card"  v-ripple="{ class: `pink--text` }" @click="selectedSubscription = subscriptionType.id" :class=" 'product-description' + (selectedSubscription === subscriptionType.id? ' subscription-type-active' : '')" style="">
                    <v-card-title
                            class="headline subscription-name" style=" font-size: 14px !important;  font-weight: 500; word-break: break-word; line-height: 1.2;"><span v-html="subscriptionType.name"></span></v-card-title>
                    <v-card-title
                            class="headline price-tag">

                        <div v-if="subscriptionType.beforePrice" style="text-decoration: line-through;height:15px;opacity:0.7" >
                            ${{subscriptionType.beforePrice}} <small style="font-weight:300;"> / mo</small>
                        </div>

                        <div style="height:15px;" >
                            ${{subscriptionType.price}} <small style="font-weight:300;"> / mo</small>
                        </div>


                    </v-card-title>


             <v-chip
                     v-if="subscriptionType.discountPercentage"
                     class="ma-2"
                     color="red"
                     outlined
                     x-small
                     style=" position: absolute; top: 21px; right: 2px; padding: 2px;"
             >
      <v-icon left style="font-size: 16px; margin-left: 0px;">mdi-fire</v-icon>
      -{{subscriptionType.discountPercentage}}%
    </v-chip>

             <v-chip
                     v-if="subscriptionType.badge"
                     class="ma-2"
                     :color="subscriptionType.badgeColor"
                     outlined
                     x-small
                     style="position: absolute; top: 23px; left: 1px; padding: 2px; padding-right: 7px;"
             >
      <v-icon left style="font-size: 16px; margin-left: 0px;">mdi-star</v-icon>
      {{subscriptionType.badge}}
    </v-chip>

              <v-radio color="pink" class="subscription-card-radio" :value="subscriptionType.id"></v-radio>

                </v-card>
        </v-col>
 </v-radio-group>
      </v-row>

      <h4 style="margin-bottom:0;margin-top:8px;" class="we-got-you-row"><span v-html="$t('paymentForm.withYou')"></span></h4>
      <div style="margin-top:0px;">
                   <v-list-item-content
                           v-for="subItem in bulletpoints"
                           :key="subItem.title"
                           style="max-height: 30px; display: block;padding:2px;font-size:11px;height:18px;overflow: visible;">
                        <v-list-item-title class="text-left we-got-you-row" style=" word-break: break-word; white-space: break-spaces;"> <v-icon class="text-action" style="font-size:12px;" v-if="!subItem.soon" v-text="subItem.soon? 'mdi-history' : 'mdi-check-circle'" ></v-icon>
                          {{subItem.title}} </v-list-item-title>
                    </v-list-item-content>

      </div>

                <v-flex style="padding-left:0px;margin-top: 75px; min-height: 80px;">
                    <div class="payment-button-container">

 <google-pay-button class="google-pay-button" :customerEmail="this.user.email"  @loadpaymentdata="$emit('completed')"
                    button-color="white"
                    style="display: flex; justify-content: center;margin-bottom:12px;"></google-pay-button>

<stripe-button  id="stripe-button" :subscription-type="selectedSubscription" class="stripe-button" :had-subscription="hadSubscription" :customer-email="this.user.email"
                                   button-color="white"
                @loadpaymentdata="_handleStripeResponse"
                                   style=""></stripe-button>               

<paypal-button  id="paypal-button" :subscription-type="selectedSubscription"  class="paypal-button" :sign-in-token="signInToken" :had-subscription="hadSubscription" :customer-email="this.user.email" @loadpaymentdata="paypalPaymentCompleted"
                button-color="white"
                style=""></paypal-button>


                   </div>


                </v-flex>

  </span>
</template>
<style>

    .subscription-card-radio {

        position:absolute;bottom: 3px; left: 4px;

    }
    .rtl .subscription-card-radio {

         left: -4px;

    }
    .subscription-card {
        cursor:pointer;position:relative; box-shadow:none;border:1px solid #cecece; margin-top:-5px;height:90px;
    }
    .mobile:not(.dark-theme) .subscription-card {
        cursor:pointer;position:relative; box-shadow:none;border:1px solid #cecece; margin-top:-5px;height:110px;;
    }

    .subscription-card {
        box-shadow:none!important;border:1px solid #cecece!important;
    }

    .subscription-card .price-tag {
        font-size:14px!important;position:absolute;right: -19px; bottom: -1px;font-weight:700;width:110px;
    }

    .rtl .subscription-card .price-tag {
        right: -10px;
    }

    .mobile:not(.dark-theme) .subscription-card .price-tag {
        font-size:14px!important;position:absolute;right: -19px; bottom: 21px;font-weight:700;width:110px;
    }

    .rtl .mobile:not(.dark-theme) .subscription-card .price-tag {
        right: -10px;
    }

    .subscription-name {
        font-size: 14px !important; padding: 5px 0 5px 7px !important; font-weight: 500; word-break: break-word; line-height: 1.2;
    }

    .rtl .subscription-name {
        padding: 5px 7px 5px 0 !important;
    }

    .mobile:not(.dark-theme) .subscription-name {
       padding-left:5px!important;
    }

    .subscription-types .subscription-type:nth-child(1){
        padding: 0 5px 0 0;
    }
    .subscription-types .subscription-type:nth-child(2){
        padding: 0 2px 0 2px;
    }
    .subscription-types .subscription-type:nth-child(3){
        padding: 0 0 0 5px;
    }

    .dark-theme.mobile .subscription-types .subscription-type {
        padding:1px;
    }

    .dark-theme.mobile{
        width: auto;
        position: absolute;
        left: 8px;
        right: 8px;

    }

    .dark-theme .product-description.subscription-type-active {
        border: 1px solid #ff287d !important;
        background: #ff287d14 !important;
    }
  .product-description.subscription-type-active {
        border: 1px solid #ff287d !important;
        background: #fff4f8 !important;
    }
    .v-card--link:focus:before {
        opacity:0!important;
    }

    .dark-theme .we-got-you-row{
        color:#fff!important;

    }

    .we-got-you-row{
        font-size:12px;
    }

    .mobile .we-got-you-row{
        font-size:10px!important;
    }

    .dark-theme .product-description {
        background-color: #444!important;
        color:#FFFFFF!important;
        max-width: 99999px; margin-left: -10px; margin-right: -10px;
    }

    .dark-theme .product-description-subtitle {

        color: rgba(255, 255, 255, 0.6) !important;
    }


    .dark-theme > .v-card__subtitle {

        color: rgba(255, 255, 255, 0.6) !important;
    }


    .dark-theme .theme--light.v-card > .v-card__text, .theme--light.v-card .v-card__subtitle {

        padding-right: 0;

    }

    .payment-button-container{
        display: flex; justify-content: center;position: absolute; left: 0; right: 0; width: 90%; margin: auto; bottom: 25px;display: flex; flex-flow: row wrap; align-content: space-between; justify-content: space-between;
    }

    .payment-button-container > * {
        width:100%;
    }

    .payment-button-container {
        width: 260px;
    }
    .google-pay-button * {
        width:100% !important;
        height:30px;
        min-height:35px;
    }
    .google-pay-button button {
        width:100% !important;
        height:30px;
        min-height:35px;
    }

   .google-pay-button button{
        padding-top: 9px!important;
        padding-bottom: 9px!important;
    }

   .payment-button-container{
        bottom: 0px !important;
    }

    .dark-theme .payment-button-container{
        bottom: -33px !important;
    }

    .dark-theme .google-pay-button *{
        width:100% !important;
        height:30px;
        min-height:35px;
    }

    .dark-theme .google-pay-button button{
        padding-top: 9px!important;
        padding-bottom: 9px!important;
    }


    .app-theme .payment-button-container {

        width:90%!important;

    }

    .v-input--radio-group--column .v-input--radio-group__input {
        flex-direction: row;
    }
</style>
<script>
    import { mapState } from 'vuex'
    import PaypalButton from '../components/paypalButton';
    import StripeButton from '../components/stripeButton';
    import GooglePayButton from '../components/payButton';
    import config from '../config';
    import i18n from "@/i18n";

    export default {
        props: ['darkTheme', 'appTheme', 'source', 'signInToken'],

        data: ()=>({
            selectedSubscription: 'SemiAnnual',
            subscriptionTypes: [
                {
                    id: 'Monthly',
                    name: i18n.t('paymentForm.monthly'),
                    price: '7.99',
                    beforePrice: false,
                    discountPercentage: false,
                    badge: false
                },
                {
                    id: 'SemiAnnual',
                    name: i18n.t('paymentForm.6Months'),
                    price: '5.99',
                    beforePrice: '7.99',
                    discountPercentage: '20',
                    // badge: 'popular',
                    badgeColor: '#FFD700'
                },
                {
                    id: 'Annual',
                    name: i18n.t('paymentForm.12Months'),
                    price: '3.99',
                    beforePrice: '7.99',
                    discountPercentage: '50',
                    // badge: 'best value',
                    badgeColor: '#a0b2c6'
                }
            ]
        }),
        created(){
        },
        computed: {
            ...mapState(['signedIn', 'user', 'hadSubscription']),
            themeClass(){
                return {
                    'dark-theme': this.darkTheme,
                    'app-theme': this.appTheme,
                    mobile: ['xs'].indexOf(this.$vuetify.breakpoint.name) > -1,
                    'small-screen': ['md', 'sm'].indexOf(this.$vuetify.breakpoint.name) > -1

                };
            },
            cardText() {
              if(this.hadSubscription){
                return i18n.t('paymentForm.body');
              }
              else {
                return i18n.t('paymentForm.freeTrialText') + i18n.t('paymentForm.body');
              }

            },
          bulletpoints() {
            var bulletpointsResult = [ { title: i18n.t('paymentForm.paypalSecured') }];

            if(!this.hadSubscription){
              bulletpointsResult = bulletpointsResult.concat([{ title: i18n.t('paymentForm.cancelNoCharge') }, {title: i18n.t('paymentForm.firstChargeCancelAnytime') }]);
            }else{

              bulletpointsResult.push({ title: i18n.t('paymentForm.cancelAnytime') })

            }
            return bulletpointsResult;
          }

        },
        methods:{
            _handleStripeResponse(){

                this.$emit('completed', {status: 'SUCCESS'});

            },
            async paypalPaymentCompleted(paymentData){

              try{
                  await this.informBackendOnPaymentComplete(paymentData);
              }catch(ex){

                  setTimeout(()=> this.informBackendOnPaymentComplete(paymentData), 1000);

              }


            },
            async informBackendOnPaymentComplete(paymentData){

                var bodyObj = {
                    'paypalSubscriptionId' : paymentData.subscriptionID,
                    'token' : this.signInToken,
                    'source' : this.source,
                    'affiliate' : localStorage.affiliate,
                    'referrer' : localStorage.referrer
                };
                var bodyStr = JSON.stringify(bodyObj);

                const response = await fetch(`${config.serverURL}/chargedPaypal`, {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: bodyStr }
                );

                const payload = await response.json();

                switch (payload.status) {
                    case 'AUTHENTICATED_WITH_SUBSCRIPTION':

                        this.$emit('completed', {status: 'SUCCESS'});

                        break;
                    case 'AUTHENTICATED_NO_SUBSCRIPTION':
                        this.$emit('completed', {status: 'ERROR'});
                        break;
                }




            }

        },
        components: {
            PaypalButton,
            GooglePayButton,
            StripeButton
        }

    }


</script>
